var _style, _ellipse, _path, _ellipse2, _ellipse3, _ellipse4, _g, _g2, _g3, _path2, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _path3, _g14, _g15, _g16, _g17, _path4, _g18, _g19, _g20, _path5, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _path6, _g29, _path7, _path8, _path9, _path10, _path11, _g30, _g31, _g32, _g33, _g34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCareerGrowth2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 1036 690"
    },
    viewBox: "0 0 1036 690",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#f5f5f5}.st1{fill:#e7e7e7}.st2{fill:#2b454e}.st3{fill:#375a64}.st4{fill:#00dfbf}.st5{opacity:.6}.st6{opacity:.5}.st7{opacity:.4}.st8{opacity:.15}.st9{fill:#1a2e35}.st10{fill:#e1e1e1}.st11{fill:#ececec}.st12,.st13{fill:#fff}.st13{opacity:.5}.st15,.st16{opacity:.6;fill:#fff}.st16{opacity:.8}.st19{opacity:.6;fill:#00dfbf}.st21{opacity:.3}.st24{fill:#ffaaa8}.st25{fill:#fafafa}.st26{fill:#ff9090}.st31{opacity:.2}.st32{fill:#f0f0f0}")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_10_",
    cx: 521.6,
    cy: 490.1,
    className: "st0",
    rx: 377.3,
    ry: 178.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shadow_10_",
    d: "M861 462 651 566h-6L342 417c-2-1-2-2 0-3l210-104h6l303 150c2 0 2 2 0 2z",
    className: "st1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_9_",
    cx: 372.5,
    cy: 562.2,
    className: "st1",
    rx: 126.3,
    ry: 62.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_8_",
    cx: 526.3,
    cy: 489.8,
    className: "st1",
    rx: 99.5,
    ry: 49.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_5_",
    cx: 747.5,
    cy: 555.6,
    className: "st1",
    rx: 62.4,
    ry: 30.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Desk"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Table_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3957_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3960_",
    d: "M656 381v159l-2 3-4 2h-4l-4-2-2-3V381c0-1 1-2 2-1l4 2h4l4-2c1-1 2 0 2 1z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3959_",
    d: "m646 545-4-2-2-3V381c0-1 1-2 2-1l4 2 2 3v159c0 1-1 2-2 1z",
    className: "st3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3954_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3956_",
    d: "M826 296v160l-2 3-4 2h-3l-4-2-2-3V296l2-1 4 2h3l4-2 2 1z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3955_",
    d: "m817 461-4-2-2-3V296l2-1 4 2 2 3v160l-2 1z",
    className: "st3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3951_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3953_",
    d: "M426 267v160l-2 3-4 2h-4l-4-2-2-3V267l2-1 4 2h4l4-2 2 1z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3952_",
    d: "m416 432-4-2-2-3V267l2-1 4 2 2 3v160l-2 1z",
    className: "st3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3938_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3949_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3950_",
    d: "M864 308v-2c0-2-2-4-4-5L559 153h-7l-185 91c-2 1-4 3-4 5v1c0 2 2 5 4 6l301 148h7l185-91 4-5z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_339_",
    d: "M864 308v-2c0-2-2-4-4-5L559 153h-7l-185 91c-2 1-4 3-4 5v1c0 2 2 5 4 6l301 148h7l185-91 4-5z",
    className: "st5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3947_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3948_",
    d: "M671 397v8l4-1 185-91c2-1 3-3 3-5v-2l-2-4c1 1 1 2-1 3l-185 91-4 1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3946_",
    d: "M671 397v8l4-1 185-91c2-1 3-3 3-5v-2l-2-4c1 1 1 2-1 3l-185 91-4 1z",
    className: "st6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3942_",
    d: "m860 305-185 91h-7L367 248c-2-1-2-3 0-4l185-91h7l301 148c2 1 2 3 0 4z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_337_",
    d: "m860 305-185 91h-7L367 248c-2-1-2-3 0-4l185-91h7l301 148c2 1 2 3 0 4z",
    className: "st7"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Keyboard_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_30_",
    d: "m649 303-44 21-5 1-130-64v-3l44-22h5l130 64v3z",
    className: "st8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Keyboard_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3931_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3936_",
    d: "m473 254 1-1 41-20h5l126 62 1 1v4l-1 1-42 20h-4l-126-62-1-1v-4z",
    className: "st9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3935_",
    d: "m605 318 41-21v-2l-126-62h-5l-41 20c-2 1-2 2 0 2l126 63h5z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3933_",
    d: "M602 318v4l3-1 41-20 1-1v-4l-1 1-41 20-3 1z",
    className: "st9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3768_",
    d: "m480 254 4-2 6 3-4 2-6-3zm7-3 4-2 4 2-4 2-4-2zm1 7 4-2 5 2-5 2-4-2zm5-10 4-2 7 4-4 2-7-4zm0 7c0-1 0-1 0 0l4-3 4 2-4 2-4-1zm2 7c0-1 0-1 0 0l4-3 4 2-4 3-4-2zm4-5 4-2 4 2-5 2-3-2zm1-12 4-2 5 3-4 2-5-3zm1 20 4-2 32 15-4 2-32-15zm1-12 4-3 4 2-4 2-4-1zm3 7 4-2 3 2-4 2-3-2zm1-18 4-2 4 1-5 3-3-2zm1 7 4-2 4 1-4 2-4-1zm1 6 4-2 4 2-4 2-4-2zm2 8 4-2 4 1-4 3-4-2zm2-18 4-3 3 2-4 2-3-1zm1 7 4-3 4 2-5 2-3-1zm1 6 4-2 3 2-4 2-3-2zm0-20 4-2 4 2-4 2-4-2zm2 28 4-2 4 1-5 2-3-1zm1-19 4-2 4 2-4 2-4-2zm2 7 4-2 3 2-4 2-3-2zm0 7 4-2 4 2-4 2-4-2zm3 7 4-2 3 2-4 2-3-2zm1-26 4-2 3 2-4 2-3-2zm0 8 4-2 4 2-5 2-3-2zm1 7 4-2 4 2-4 2-4-2zm1 7 4-2 4 1-4 2-4-1zm2 7 4-2 4 2-4 2-4-2zm1-26 4-2 4 2-4 2-4-2zm1 8 4-2 3 2-4 2-3-2zm1 7 4-2 4 1-5 3-3-2zm1 7 4-2 3 1-4 2-3-1zm2 7 4-2 3 2-4 2-3-2zm1-26 4-2 4 2-4 2-4-2zm0 8 4-2 4 1-4 2-4-1zm1 25 4-2 4 2-4 2-4-2zm1-18 4-2 3 1-4 2-3-1zm0 6 4-2 4 2-4 2-4-2zm3 8 4-2 3 1-4 2-3-1zm1-26 4-2 3 1-4 3-3-2zm0 8 4-3 3 2-4 2-3-1zm1 7 4-3 4 2-4 2-4-1zm0 19 4-3 5 2-4 3-5-2zm1-13 4-2 4 2-5 2-3-2zm2 8 4-2 4 1-4 2-4-1zm2-19 4-2 3 2-4 2-3-2zm1 7 4-2 3 2-4 2-3-2zm1 7 4-2 3 2-4 2-3-2zm0-20 4-2 3 1-4 3-3-2zm0 33 4-2 4 2-4 2-4-2zm2-6 4-2 3 2-4 2-3-2zm1-18 4-2 4 2-4 2-4-2zm2 7 4-2 3 2-4 2-3-2zm0 7 4-2 4 1-4 2-4-1zm0-20 4-2 4 1-4 2-4-1zm1 33s1 0 0 0l4-2 6 3-4 2-6-3zm2-6 4-2 11 5-5 3-10-6zm1-18 4-2 3 1-4 3-3-2zm1 7 4-2 4 1-4 3-4-2zm1 7 4-2 4 1-5 2-3-1zm0-21 4-2 4 2-4 2-4-2zm3 10s1 0 0 0l4-2 4 1-4 2-4-1zm1 25 4-2 4 2-4 2-4-2zm1-18 4-2 3 1-4 2-3-1zm1 6 4-2 3 2h2l5-3 4 2-10 5-8-4zm0-20 4-2 3 2-4 2-3-2zm3 10 4-3 4 2-4 2-4-1zm1 25 4-2 4 2-4 2-4-2zm0-18s1-1 0 0l4-3 4 2-4 2-4-1zm4-13 4-2 3 2-4 2-3-2zm1 8 4-2 3 2-4 2-3-2zm1 26 4-2 3 2-4 2-3-2zm0-6 4-2 4 2-4 2-4-2zm4-25 4-2 3 2-4 2-3-2zm0 8 4-2 7 3-4 2-7-3zm3 26 4-2 9 5-4 2-9-5zm1-18 4-2 3 2-4 2-3-2zm1-13 4-2 4 1-4 2-4-1zm4 28 4-2 4 2-5 2-3-2zm0-12 4-2 4 1-4 2-4-1zm1-6 4-2 4 1-5 2-3-1zm1-7 4-2 3 1-4 2-3-1zm3 34 4-2 3 2-4 2-3-2zm1-6 4-2 3 2-4 2-3-2zm0-12 4-3 3 2-4 2-3-1zm0 6 4-2 4 2-4 2-4-2zm1-12 4-2 3 1-4 2-3-1zm2-7 4-2 3 2-4 2-3-2zm2 34 10-5 4 1-11 6-3-2zm0-6 4-2 4 1-4 2-4-1zm1-6 4-2 4 1-5 3-3-2zm0-13 4-2 4 2-4 2-4-2zm1 7 4-2 3 1-4 3-3-2zm1-13 4-2 4 1-4 2-4-1zm4 22 4-2 3 1-4 2-3-1zm0-6 4-2 4 1-4 2-4-1zm1-6 4-2 4 1-4 2-4-1zm1-7 4-2 4 1-4 2-4-1zm3 22c0-1 0-1 0 0l11-6 3 2-10 5-4-1zm1-6 4-3 4 2-4 2-4-1zm1-6 4-2 3 1-4 2-3-1zm4-8 1-1 4 2-2 1-3-2zm1 10 4-2 4 2-4 2-4-2zm4-7 2-1 3 2-1 1-4-2zm2 10 4-2 4 2-4 2-4-2zm4-7 2-1 3 2h-2l-3-1zm5 3s1 0 0 0l2-1 4 1-2 1-4-1z",
    className: "st4"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_29_",
    d: "m750 307 39-19-193-96-39 20z",
    className: "st8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Monitor_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3761_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3766_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3767_",
    d: "m641 276-28-14c-3-1-4-3-4-5v-3l26-13 2-4v-29l49 24v29l-3 4-22 11c-5 3-15 3-20 0z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3765_",
    d: "M674 266v3l9-4 3-4v-29l-10-5v6l6 4v22c0 2-1 4-3 4l-5 3z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3764_",
    d: "m682 259-2 4-19 10c-5 2-15 2-20 0l-28-14c-6-3-6-7 0-10l19-9 2-4v-23l48 24v22z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3763_",
    d: "m626 242 5-2c2-1 3-3 3-5v-22l48 24v22l-2 4-6 3-48-24z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3762_",
    d: "M609 254v3c0 2 1 4 4 5l28 14 9 2v-3l-9-2-28-14c-3-1-4-3-4-5z",
    className: "st11"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3760_",
    d: "M760 291h-7l-186-92c-2-1-4-4-4-6V54c0-2 2-4 4-5h6l187 92c1 1 3 3 3 5v140c0 2-1 4-3 5z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3758_",
    d: "m753 291-186-92-4-5V54c0-2 2-3 4-2l186 92c2 1 3 3 3 5v140c1 2-1 3-3 2z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3757_",
    d: "M754 291h6c1-1 3-3 3-5v-16l-7 4v15c1 2-1 3-2 2z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3756_",
    d: "M757 274v15c0 2-2 3-4 2l-186-92c-2-1-4-3-4-5v-16l194 96z",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3755_",
    d: "M750 262V151l-2-3-176-87-2 1v111l2 3 176 87 2-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3754_",
    d: "M750 262V151l-2-3-176-87-2 1v111l2 3 176 87 2-1z",
    className: "st13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3658_",
    d: "M660 232c2 1 3 3 3 5 0 1-1 2-3 1s-3-3-3-5c0-1 1-2 3-1z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3657_",
    d: "m756 146 1 3v125l6-4V146l-1-3-6 3z",
    className: "st9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Window_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window_3_"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M594 25v-1h3l218 107c1 1 3 3 3 5v135l-1 2h-3l-3-1-214-106c-2-1-3-3-3-5V25z",
    className: "st3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3010_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3044_",
    d: "M595 24h2l218 107c1 1 3 3 3 5v9l4-2v-9c0-2-1-4-3-5L601 22h-2l-4 2z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3036_",
    d: "M594 25c0-1 1-2 3-1l217 107c2 1 4 3 4 5v9L594 35V25z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3027_",
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m597 24 218 107 2 2 4-2-2-2L601 22h-2l-4 2h2z",
    className: "st12"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3011_",
    d: "M822 143v-9l-1-3-4 2 1 3v9l4-2z",
    className: "st8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3000_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3009_",
    d: "m810 133 2 3c0 2-1 3-2 2l-2-3 2-2z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3002_",
    d: "m804 130 2 3c0 2-1 2-2 2l-2-4c0-1 1-2 2-1z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3001_",
    d: "m797 127 2 3c0 1-1 2-2 1l-2-3c0-1 1-2 2-1z",
    className: "st3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m817 273 3-2 2-2V143l-4 2v126l-1 2z",
    style: {
      opacity: 0.9,
      fill: "#1a2e35"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2979_",
    d: "m660 83 46 22 1 2h-1l-46-22-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2977_",
    d: "m678 126 17 9 1 1c1 1 0 1-1 1l-17-9-1-2h1z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2971_",
    d: "m678 135 17 8 1 2h-1l-17-8-1-2h1z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2967_",
    d: "m711 107 92 46 1 1-1 1-92-45-1-2 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2926_",
    d: "m678 187 28 13 1 2-1 1-28-14-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2925_",
    d: "m711 203 92 45 1 2h-1l-92-45-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2876_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2905_",
    d: "m660 91 23 12 2 1-1 1-24-11-1-2 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2890_",
    d: "m660 91 23 12 2 1-1 1-24-11-1-2 1-1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2873_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2875_",
    d: "m660 100 11 5 1 2h-1l-11-5-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2874_",
    d: "m660 100 11 5 1 2h-1l-11-5-1-2h1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2867_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2869_",
    d: "m660 117 11 6 1 1-1 1-11-6-1-1 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2868_",
    d: "m660 117 11 6 1 1-1 1-11-6-1-1 1-1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2864_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2866_",
    d: "m660 126 11 5 1 2h-1l-11-5-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2865_",
    d: "m660 126 11 5 1 2h-1l-11-5-1-2h1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2855_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2863_",
    d: "m688 105 14 7 1 1-1 1-14-7-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2862_",
    d: "m688 105 14 7 1 1-1 1-14-7-1-2h1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2853_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2854_",
    d: "m709 167 93 46 2 2-1 1-94-46-1-2 1-1z",
    className: "st12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2851_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2852_",
    d: "m789 198 13 7 2 1-2 1-13-7-2-2h2z",
    className: "st12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2849_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2850_",
    d: "m691 150 93 45 1 2-1 1-93-46-1-2h1z",
    className: "st12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2846_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2848_",
    d: "m678 109 23 11 1 2h-1l-23-11-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2847_",
    d: "m678 109 23 11 1 2h-1l-23-11-1-2h1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2823_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2845_",
    d: "m706 122 96 48 1 2h-1l-97-48-1-1 2-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2839_",
    d: "m706 122 96 48 1 2h-1l-97-48-1-1 2-1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2978_",
    d: "m678 161 124 61 2 2h-1l-125-61-1-2h1z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2870_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2872_",
    d: "m660 152 11 5 1 2-1 1-11-6-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2871_",
    d: "m660 152 11 5 1 2-1 1-11-6-1-2h1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2986_",
    d: "m678 169 124 62 2 2h-1l-125-61-1-2 1-1z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2981_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2984_",
    d: "m660 161 11 5 1 2h-1l-11-5-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2983_",
    d: "m660 161 11 5 1 2h-1l-11-5-1-2h1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2994_",
    d: "m678 178 124 61 2 2-1 1-125-62-1-2h1z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2991_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2993_",
    d: "m660 169 11 6 1 1-1 1-11-5-1-2 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2992_",
    d: "m660 169 11 6 1 1-1 1-11-5-1-2 1-1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m644 74 6 3 1 2v2h-1l-7-3-1-1v-2l2-1zM644 83l6 3 1 1v2l-1 1-7-3-1-2v-2h2zM644 91l6 4 1 1v2l-1 1-7-3-1-2v-2l2-1zM644 100l6 3 1 2v2h-1l-7-3-1-1v-2l2-1zM644 109l6 3 1 2v2h-1l-7-3-1-2v-2h2zM644 118l6 3 1 1v2l-1 1-7-3-1-2v-2h2zM644 126l6 3 1 2v2l-1 1-7-3-1-2v-2l2-1zM644 135l6 3 1 2v2h-1l-7-3-1-1v-2l2-1zM644 144l6 3 1 2v2h-1l-7-3-1-2v-2h2zM644 153l6 3 1 1v2l-1 1-7-3-1-2v-2h2zM644 161l6 3 1 2v2l-1 1-7-3-1-2v-2l2-1zM644 170l6 3 1 2v2h-1l-7-3-1-1v-2l2-1z",
    className: "st12"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m601 46 35 17 2 3v34c0 1-1 2-2 1l-35-17-2-3V47c0-2 1-2 2-1z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2822_",
    d: "m605 79 3 2 1 1-1 1-3-2-2-1 2-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2821_",
    d: "m605 79 3 2 1 1-1 1-3-2-2-1 2-1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2820_",
    d: "m605 51 3 2 1 2h-1l-3-1-2-2 2-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_529_",
    d: "m605 51 3 2 1 2h-1l-3-1-2-2 2-1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 59 3 2 2 1-2 1-3-2-1-1 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 59 3 2 2 1-2 1-3-2-1-1 1-1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 65 3 1 2 2-2 1-3-2-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 65 3 1 2 2-2 1-3-2-1-2h1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605 68 3 2 1 1-1 1-3-2-2-1 2-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605 68 3 2 1 1-1 1-3-2-2-1 2-1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 76 3 1 2 2-2 1-3-2-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 76 3 1 2 2-2 1-3-2-1-2h1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_354_",
    d: "m613 56 20 9 1 2h-1l-20-9-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_353_",
    d: "m613 56 20 9 1 2h-1l-20-9-1-2h1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_352_",
    d: "m613 83 20 10 1 2h-1l-20-9-1-2 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_343_",
    d: "m613 83 20 10 1 2h-1l-20-9-1-2 1-1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 63 15 8 1 1-1 1-15-7-1-2 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 63 15 8 1 1-1 1-15-7-1-2 1-1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 69 15 7 1 2-1 1-15-8-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 69 15 7 1 2-1 1-15-8-1-2h1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613 72 20 10 1 1-1 1-20-9-1-2 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613 72 20 10 1 1-1 1-20-9-1-2 1-1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 80 15 7 1 2-1 1-15-8-1-1 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 80 15 7 1 2-1 1-15-8-1-1 1-1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m601 90 35 17 2 4v67c0 1-1 2-2 1l-35-17-2-3V92c0-2 1-2 2-2z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_342_",
    d: "m605 96 3 2 1 1-1 1-3-2-2-1 2-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_341_",
    d: "m605 96 3 2 1 1-1 1-3-2-2-1 2-1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 104 3 2 2 1-2 1-3-2-1-1 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 104 3 2 2 1-2 1-3-2-1-1 1-1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 110 3 1 2 2h-2l-3-1-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 110 3 1 2 2h-2l-3-1-1-2h1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605 113 3 2 1 1-1 1-3-2-2-2h2z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605 113 3 2 1 1-1 1-3-2-2-2h2z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_340_",
    d: "m613 101 20 9 1 2h-1l-20-9-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_321_",
    d: "m613 101 20 9 1 2h-1l-20-9-1-2h1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 108 15 8 1 1-1 1-15-7-1-2 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 108 15 8 1 1-1 1-15-7-1-2 1-1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 114 15 7 1 2h-1l-15-7-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 114 15 7 1 2h-1l-15-7-1-2h1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613 117 20 10 1 1-1 1-20-10-1-1 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613 117 20 10 1 1-1 1-20-10-1-1 1-1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 121 3 1 2 2-2 1-3-2-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 121 3 1 2 2-2 1-3-2-1-2h1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 126 3 2 2 1-2 1-3-2-1-1 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 126 3 2 2 1-2 1-3-2-1-1 1-1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 125 15 7 1 2-1 1-15-8-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 125 15 7 1 2-1 1-15-8-1-2h1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 131 15 7 1 2h-1l-15-7-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 131 15 7 1 2h-1l-15-7-1-2h1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605 141 3 1 1 2-1 1-3-2-2-2h2z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605 141 3 1 1 2-1 1-3-2-2-2h2z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613 145 20 10 1 1-1 1-20-10-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613 145 20 10 1 1-1 1-20-10-1-2h1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 149 3 1 2 2h-2l-3-1-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 149 3 1 2 2h-2l-3-1-1-2h1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 154 3 2 2 1-2 1-3-2-1-1 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 154 3 2 2 1-2 1-3-2-1-1 1-1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 153 15 7 1 2h-1l-15-7-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 153 15 7 1 2h-1l-15-7-1-2h1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 158 15 8 1 2h-1l-15-7-1-2 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 158 15 8 1 2h-1l-15-7-1-2 1-1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 132 3 1 2 2h-2l-3-1-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609 132 3 1 2 2h-2l-3-1-1-2h1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605 135 3 2 1 1-1 1-3-2-2-1 2-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605 135 3 2 1 1-1 1-3-2-2-1 2-1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 136 15 7 1 2-1 1-15-8-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618 136 15 7 1 2-1 1-15-8-1-2h1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613 139 20 10 1 2h-1l-20-9-1-2 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613 139 20 10 1 2h-1l-20-9-1-2 1-1z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605 158 3 1 1 2h-1l-3-1-2-2h2z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605 158 3 1 1 2h-1l-3-1-2-2h2z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613 162 20 9 1 2-1 1-20-10-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m613 162 20 9 1 2-1 1-20-10-1-2h1z",
    className: "st16"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Window_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3556_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3571_",
    d: "M792 185v110l3 4 74 36h2v-1l1-1V224c0-2-2-4-3-4l-74-37h-2l-1 1v1z",
    className: "st3",
    style: {
      opacity: 0.8
    }
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3563_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3568_",
    d: "M793 183h2l74 37c1 0 3 2 3 4v7l4-2v-7c0-2-1-4-3-4l-74-37h-2l-4 2z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3567_",
    d: "M792 185c0-2 2-2 3-2l74 37c1 0 3 2 3 4v7l-80-39v-7z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3566_",
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m795 183 74 37 2 1 4-2-2-1-74-37h-2l-4 2h2z",
    className: "st12"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3564_",
    d: "M876 229v-7l-1-3-4 2 1 3v7l4-2z",
    className: "st8"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3559_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3562_",
    d: "m868 223 1 3-1 1-2-3c0-1 1-2 2-1z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3561_",
    d: "m862 220 2 3-2 1-1-3 1-1z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3560_",
    d: "m857 217 1 3c0 1 0 2-1 1l-2-2 2-2z",
    className: "st3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3558_",
    d: "M871 335h1v-1h1l1-1h1v-1l1-1V229l-5 2v104z",
    className: "st2",
    style: {
      opacity: 0.9
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2916_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3493_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3552_",
    d: "M799 205v-1l2-1v2l-1 1 1 1v2l-2-3v-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3548_",
    d: "M806 203h1v1l-3 9h-1l-1-1 4-9z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3541_",
    d: "m811 212-2 1h-1v-2h1l-1-2v-2h1l2 3v2z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3522_",
    d: "M816 216v2h-1v-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3499_",
    d: "M819 218v2l-1-1v-2l1 1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3497_",
    d: "M822 219v2h-1v-2h1z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3489_",
    d: "m799 215 45 22 1 1h-1l-45-22-1-1h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3488_",
    d: "m814 243 44 22 1 1h-1l-44-22-1-1h1z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3480_",
    d: "m814 257 21 10 1 2h-1l-21-10-1-2h1z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3458_",
    d: "m847 239 18 8 1 1-1 1-18-9-1-1h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3455_",
    d: "m799 292 45 22 1 1-1 1-45-22-1-1 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3452_",
    d: "m847 316 18 9 1 1h-1l-18-9-1-1h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3448_",
    d: "m847 295 18 9 1 1h-1l-18-9-1-1h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3288_",
    d: "m847 302 18 9 1 1h-1l-18-9-1-1h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3285_",
    d: "m832 287 10 5 1 1-1 1-10-5-1-1 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3242_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3244_",
    d: "m799 222 26 13 1 1h-1l-26-12-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3243_",
    d: "m799 222 26 13 1 1h-1l-26-12-1-2h1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3239_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3241_",
    d: "m799 229 9 4 1 1-1 1-9-4-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3240_",
    d: "m799 229 9 4 1 1-1 1-9-4-1-2h1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3236_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3238_",
    d: "m799 236 9 4 1 1-1 1-9-4-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3237_",
    d: "m799 236 9 4 1 1-1 1-9-4-1-2h1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3234_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3235_",
    d: "m799 243 9 4 1 2h-1l-9-4-1-2h1z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3233_",
    d: "m799 243 9 4 1 1-1 1-9-4-1-2h1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3232_",
    d: "m814 250 26 13v1h-1l-25-12-1-2h1z",
    className: "st19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3228_",
    d: "m843 265 12 5v1l-1 1-11-6-1-1h1z",
    className: "st19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3205_",
    d: "m814 250 26 13v1h-1l-25-12-1-2h1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3204_",
    d: "m843 265 12 5v1l-1 1-11-6-1-1h1z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3201_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3203_",
    d: "m799 250 9 4 1 2h-1l-9-4-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3202_",
    d: "m799 250 9 4 1 2h-1l-9-4-1-2h1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3198_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3200_",
    d: "m829 236 11 6 1 1-1 1-11-6-1-1 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3199_",
    d: "m829 236 11 6 1 1-1 1-11-6-1-1 1-1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3196_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3197_",
    d: "m824 269 26 13 1 1-1 1-26-13-1-1 1-1z",
    className: "st12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3194_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3195_",
    d: "m839 284 26 12 1 2h-1l-26-13-1-1h1z",
    className: "st12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3094_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3193_",
    d: "m854 284 11 5 1 2h-1l-11-5-1-2h1z",
    className: "st12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2998_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2999_",
    d: "m854 312 11 5 1 2h-1l-11-6-1-1h1z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2995_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2997_",
    d: "m814 236 26 13v1h-1l-25-12-1-2h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2996_",
    d: "m814 236 26 13v1h-1l-25-12-1-2h1z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2918_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2922_",
    d: "m843 250 12 6v1l-1 1-11-6-1-1 1-1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2919_",
    d: "m843 250 12 6v1l-1 1-11-6-1-1 1-1z",
    className: "st15"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Mouse_2_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m667 331 16 8c5 2 12 2 17-1l26-16c5-3 5-8 0-10l-8-4c-5-2-13-3-19 0l-32 15c-5 2-5 6 0 8z",
    className: "st8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m727 315-18 12-14 9-4 1-6-2-15-7c-5-2-6-8-3-12h1c3-4 7-6 11-7l7-1c12-2 22-3 23-2l18 9z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717 321h1l-16-8 14-4-2-1-14 4-9-5-2 1 28 13z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m697 335 13-8 17-11v-2l-18 5-6 2-5 3c-4 3-7 7-7 12h4l2-1z",
    className: "st9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Pot_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3653_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3654_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3655_"
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3717_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3718_",
    d: "M728 552c-17-15-27-78-10-90h86c17 12 7 75-10 90l-1 1h-1l-1 1-1 1-1 1-2 1c-15 7-38 7-52 0l-2-2h-2v-1l-2-1-1-1z",
    className: "st4"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3668_",
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3669_",
    d: "M728 552c-17-15-27-78-10-90h86c17 12 7 75-10 90l-1 1h-1l-1 1-1 1-1 1-2 1c-15 7-38 7-52 0l-2-2h-2v-1l-2-1-1-1z",
    className: "st12"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3666_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3667_",
    d: "M797 457c20 10 20 26 0 36a90 90 0 0 1-72 0c-20-10-20-26 0-36s52-10 72 0z",
    className: "st4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3664_",
    style: {
      opacity: 0.7
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3665_",
    d: "M797 457c20 10 20 26 0 36a90 90 0 0 1-72 0c-20-10-20-26 0-36s52-10 72 0z",
    className: "st12"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3662_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3663_",
    d: "M787 462c15 7 15 19 0 26s-38 7-52 0c-15-7-15-19 0-26 14-8 38-8 52 0z",
    className: "st4"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3660_",
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3661_",
    d: "M787 462c15 7 15 19 0 26s-38 7-52 0c-15-7-15-19 0-26 14-8 38-8 52 0z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3656_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3659_",
    d: "M735 474c14-7 38-7 52 0l9 7c-2 3-5 5-9 7-14 7-38 7-52 0l-9-7 9-7z",
    className: "st0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Plants_20_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3595_"
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3645_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3652_",
    d: "m754 442-2-5c-1-4 0-10 4-12l5-4v-3c-1-4-2-8-1-12 1-3 4-6 8-7l12-3 7-2 5-5c1-2 3-4 6-5 4-4 9-6 16-6 12 1 12 10 8 17-3 7-4 9 4 17 8 7 8 16-2 22-9 5-16 5-12 15 4 9 6 16-4 26-6 6-14 10-25 10-3 0-9-1-12-3-3-1-1-3-2-5l-6-16-5-12-4-7z",
    className: "st4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3643_",
    style: {
      opacity: 0.25
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3644_",
    d: "m754 442-2-5c-1-4 0-10 4-12l5-4v-3c-1-4-2-8-1-12 1-3 4-6 8-7l12-3 7-2 5-5c1-2 3-4 6-5 4-4 9-6 16-6 12 1 12 10 8 17-3 7-4 9 4 17 8 7 8 16-2 22-9 5-16 5-12 15 4 9 6 16-4 26-6 6-14 10-25 10-3 0-9-1-12-3-3-1-1-3-2-5l-6-16-5-12-4-7z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3641_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3642_",
    d: "M771 482h1c-1-54 34-87 34-87v-1h-1s-36 33-35 88h1z",
    className: "st12"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3598_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3640_",
    d: "M781 432c12-6 32-11 32-11l1-1h-1c-1 0-21 4-32 11l-1 1h1z",
    className: "st12"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3596_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3597_",
    d: "M785 425v-1c-4-9-10-15-10-15h-1v1s6 6 10 14l1 1z",
    className: "st12"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3098_"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3594_",
    d: "M762 488s-11 4-27 1-26-16-26-16 17-5 27-6c0 0-15-2-30 1 0 0-9-3-7-17 0 0 9-5 29-3 0 0-10-6-28-8l2-25c2-8 5-6 12-6 8 1 29 5 31 10 3 4 1 15 1 15s5-6 5-14c0 0 8 2 13 5 4 3 6 6 7 8-1 6-4 16-9 21 0 0 11-6 13-17 0 0 8 10 8 21 0 14-7 24-21 30z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3719_",
    d: "M762 488s-11 4-27 1-26-16-26-16 17-5 27-6c0 0-15-2-30 1 0 0-9-3-7-17 0 0 9-5 29-3 0 0-10-6-28-8l2-25c2-8 5-6 12-6 8 1 29 5 31 10 3 4 1 15 1 15s5-6 5-14c0 0 8 2 13 5 4 3 6 6 7 8-1 6-4 16-9 21 0 0 11-6 13-17 0 0 8 10 8 21 0 14-7 24-21 30z",
    style: {
      opacity: 0.1
    }
  }), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3578_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3579_",
    d: "m765 487-1-1c-3-25-36-66-51-74v-1h1c15 8 49 49 52 75l-1 1z",
    className: "st12"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_179_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_183_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_191_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_192_",
    d: "m460 471-5-17s2 1 13-1c6-1 12-5 12-5l4 13c3 4 13 2 23 1l6-1v1c6-1 12 2 6 7-6 4-16 6-26 7-11 2-30 4-33-5z",
    className: "st24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_184_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_190_",
    d: "m539 469 1 5c-1 2-6 9-16 13-9 3-21 4-26 5l-17 5c-7 2-13 2-20-1l-2-6 80-21z",
    className: "st9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_189_",
    d: "M485 462c5 3 13 1 23 0 8-1 18-3 24-2 6 2 11 8 3 16-2 2-7 6-11 7-10 3-19 4-26 5-8 2-13 5-21 6-10 1-16-2-18-4-1-2-3-21 1-20 0 0 2 6 19 0 7-3 7-6 6-8z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_188_",
    d: "M485 462c5 3 13 1 23 0 8-1 18-3 24-2 6 2 11 8 3 16-2 2-7 6-11 7-10 3-19 4-26 5-8 2-13 5-21 6-10 1-16-2-18-4-1-2-3-21 1-20 0 0 2 6 19 0 7-3 7-6 6-8z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_187_",
    d: "M513 472s-1-7-7-10l-4 1s6 1 8 10h2l1-1z",
    className: "st25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_186_",
    d: "M496 463h4s5 2 6 10l-2 1h-2s-1-9-6-11z",
    className: "st25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_185_",
    d: "m491 464 1-1 2 1s4 3 4 10l-2 1-2-1s0-9-3-10z",
    className: "st25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_180_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_181_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_182_",
    d: "M454 357c8 22 30 95 30 95s-15 11-30 6l-37-91 37-10z",
    className: "st2"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_166_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_169_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_177_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_178_",
    d: "m517 495-8-17s7 3 18 0c6-1 11-6 11-6l5 14c3 5 12 3 23 3l6-1c6 0 12 3 5 7-6 4-16 6-25 7-12 1-29 1-35-7z",
    className: "st24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_170_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_176_",
    d: "m602 494 1 6c-1 2-7 8-17 12s-23 4-29 5l-18 6c-7 1-14 2-21-2l-2-6 86-21z",
    className: "st9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_175_",
    d: "m545 485 2 1 2 1h6l13-1c10-1 21-4 27-2s12 9 3 17l-12 8c-10 4-21 3-28 4-9 2-14 5-23 6-11 1-17-2-19-4l-1-15c-2-4-1-8 1-8l1 2 3 2 4 1 8 1 2-1 1-2v-2l1-1 1-1 4-3 1-3 1-1 1 1h1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_174_",
    d: "m545 485 2 1 2 1h6l13-1c10-1 21-4 27-2s12 9 3 17l-12 8c-10 4-21 3-28 4-9 2-14 5-23 6-11 1-17-2-19-4l-1-15c-2-4-1-8 1-8l1 2 3 2 4 1 8 1 2-1 1-2v-2l1-1 1-1 4-3 1-3 1-1 1 1h1z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_173_",
    d: "M574 497s0-9-8-11h-4s7 1 9 11h3z",
    className: "st25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_172_",
    d: "m556 487 2-1h2s5 2 6 11l-2 1h-2s0-10-6-11z",
    className: "st25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_171_",
    d: "m550 487 2-1 2 1s4 3 3 11c1 0 1 1-1 1l-2-1s0-10-4-11z",
    className: "st25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_167_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_168_",
    d: "M512 382c6 17 23 66 30 91 0 0-13 11-31 10l-42-94 17-9 26 2z",
    className: "st3"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_144_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_164_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_165_",
    d: "m373 616 2-2V463c0-1-1-2-3-2l-2 2v151c0 1 1 2 3 2z",
    className: "st3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_162_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_163_",
    d: "m264 562 2-2 54-117c1-1 0-2-1-3l-4 1-54 117c-1 2 0 3 2 3l1 1z",
    className: "st3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_160_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_161_",
    d: "m270 548 2-1 101-91 100 90h4v-3l-103-92-1-1-2 1-103 93v3l2 1z",
    className: "st3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_158_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_159_",
    d: "m481 562 1-1c2 0 2-2 2-3l-54-117-4-1c-1 1-2 2-1 3l54 117 2 2z",
    className: "st3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_156_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_157_",
    d: "M483 412c2-10-7-17-24-27s-39-19-49-24c-15-5-29-5-47 3-25 11-101 51-101 51s113 54 135 52 76-33 81-43l5-12z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_154_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_155_",
    d: "M483 412c2-10-7-17-24-27s-39-19-49-24c-15-5-29-5-47 3-25 11-101 51-101 51s113 54 135 52 76-33 81-43l5-12z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_152_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_153_",
    d: "M386 456c16 12 33 1 60-14 31-16 37-30 37-30s0 10-3 15c-2 5-7 10-29 23s-37 20-52 22l-12-1",
    className: "st4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_151_",
    d: "M446 443c31-17 37-31 37-31s0 10-3 15c-2 5-7 10-29 23s-38 20-52 22l-12-1-1-15c16 12 33 1 60-13z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_149_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_150_",
    d: "m268 543-8 17h-1l2 1 4 1 1-1 8-16-6-2z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_147_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_148_",
    d: "m478 544 7 16v1l-1 1h-4l-1-1-7-15 6-2z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_145_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_146_",
    d: "M369 602v14l1 1h5l1-1v-14h-7z",
    className: "st4"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_125_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_128_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_143_",
    d: "M307 355c7 7 66-8 81-10 25-3 46-5 54-2 9 2 12 6 15 14l4 16s-41 13-74 17c-33 3-80-35-80-35z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_126_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_127_",
    d: "M296 365c-6 21-12 46 3 59 10 9 61 33 94 23 32-9 100-51 106-56 7-4 13-7 12-9-9-25-22-27-46-23-30 6-96 29-96 29l-73-23z",
    className: "st3"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_122_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_123_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_124_",
    d: "m445 228-22 22-37-15 26-30z",
    className: "st24"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_117_"
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_120_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_121_",
    d: "M473 187s10 11 9 12l-8 2-1-14z",
    className: "st26"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 473.3,
    cy: 184.7,
    rx: 10.1,
    ry: 8.6,
    style: {
      fill: "none",
      stroke: "#1a2e35",
      strokeWidth: 1.207,
      strokeMiterlimit: 10
    }
  }), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_118_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_119_",
    d: "M448 155c18 3 23 10 26 34 2 26-1 34-5 38-2 2-17 3-24 1-10-2-31-8-41-21-12-15-16-35-4-44 17-12 40-9 48-8z",
    className: "st24"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M445 228c8 2 20 1 24-1h-14l-12-5 2 6z",
    className: "st26"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_110_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_114_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_115_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_116_",
    d: "M477 165c-5 3-11 4-17 5l-3 12c-1 3-5 12-9 7-3-3-6-7-11-6-10 2-11 12-5 18s12 4 12 4 1 11-6 19c0 0-10 5-25 1-9-2-22-12-26-20-14-21-14-41 2-47 2-10 11-15 21-17 15-3 30 5 44 0l8-4h6l2 3c0 3 1 5-1 8l7-3c2 0 5 0 6 2 2 1 3 3 3 5 1 5-3 10-8 13z",
    className: "st9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_111_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_112_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_113_",
    d: "m389 161-11-5c2-3 6-3 9-2 3 2 4 5 2 7z",
    className: "st9"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m448 189 35-6",
    style: {
      fill: "none",
      stroke: "#1a2e35",
      strokeWidth: 1.027,
      strokeMiterlimit: 10
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m522 241-5-2-9-4c-4-2-8-2-11-1a40 40 0 0 0-11 4c-9 4-15 15-24 19l-9 5 21 16 10-7c5-2 10-2 16-3l12-2 3-2c1-2 0-3-2-4l-6-1h-6v-3c4-3 8-8 14-9l5-1c2-2 3-4 2-5z",
    className: "st24"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M397 223c-23-10-43-4-50 10-7 12-21 58-21 58 7 11 71-68 71-68z",
    className: "st4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m393 227 3-4c-25-10-47 3-67 30-21 28-32 69-33 112 0 0 5 19 33 29 30 10 73 6 86-21 0 0 0-27 10-40l31-41c9-12 17-39-3-49l-16-7c-17 5-46-3-44-9z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m393 227 3-4c-25-10-47 3-67 30-21 28-32 69-32 112 0 0 4 19 32 29 31 10 73 6 86-21 0 0 0-27 10-40l31-42c9-11 17-38-3-48l-16-7c-17 5-46-3-44-9z",
    style: {
      opacity: 0.75,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 275c1-6 2-11 1-16-5 9-11 17-19 25-10 9-23 16-32 26-10 10-18 23-26 34-3 5-8 13-14 14-8 0-15-8-19-13-7-9-13-20-21-28-7-6-18-15-28-11l-2 7-2 7-2 7-1 7c-2 10-3 21-3 31 0 0 5 19 33 29 30 10 73 6 86-21 0 0 0-27 10-40l3-5 4-5a3982 3982 0 0 1 10-14l9-12 3-4 2-1 1-1v-1l1-1 1-2 1-2 1-2 1-2 1-3 1-3z",
    style: {
      opacity: 0.1,
      fill: "#00dfbf"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m581 301-6 4c-7 6-16 9-27 15l-32 17c-12 7-27 12-35 14-11 3-16 3-22-11l-8-21-11-31s-14-29 16-43c14 6 19 9 23 23l13 48c10-4 21-7 31-12 4-1 9-2 11-5l5-7 4-6 10-9 2-1c1-1 2 0 2 1 2 2 1 3 0 5l-2 6c8-4 14-9 19-16l2-2h2c2 0 4 3 4 4v5l2 4 2 5c0 4-1 7-3 10l-2 3z",
    className: "st24"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M455 244c11 4 19 8 25 23l11 40s0 5-14 12-27 3-27 3l-11-29s-19-39 16-49z",
    className: "st4"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_105_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    d: "M387 471c-9-1-16-7-38-14-41-15-71-27-83-45s-20-71-17-93l2-8h-3l7-6c8-5 20 0 30 4 26 12 47 24 64 68 12 33 20 63 37 79",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_108_",
    d: "M251 311h-3l7-6c8-5 20 0 30 4 26 13 47 25 64 68 12 33 20 63 37 79l1 15c-9-1-16-7-38-14-41-15-72-27-83-45-12-18-20-71-17-93l2-8z",
    className: "st21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_106_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_107_",
    d: "M277 315c26 12 47 24 64 68 16 43 25 82 58 89 0 0-15 5-60-11-14-5-32-15-43-20-22-11-36-20-38-23-12-18-20-71-17-94 3-22 23-15 36-9z",
    className: "st4"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3721_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3751_",
    d: "m427 122-8-12 6-15v-8l-18 8v9l8 12 12 6z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3749_",
    d: "m427 122-8-12 6-15v-8l-18 8v9l8 12 12 6z",
    className: "st31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3747_",
    d: "M470 15c0-3-3-6-6-8l-4-2h-11l-68 34c-3 1-5 5-5 8v64c0 3 2 6 5 8l5 2h11l21-11 8 11h2l9-20 27-14c3-1 6-5 6-8V15z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3727_",
    d: "M376 111c0 3 2 6 5 8l5 2h10c-3 1-5 0-5-3V54l2-4-16-8-1 5v64z",
    className: "st31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3723_",
    d: "M470 14c-1-2-3-3-6-1l-67 33-4 4-15-8 3-3 68-34h11l4 2c3 2 5 4 6 7z",
    className: "st13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C__x2F__x3E__2_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401 79v-1l1-1 15-21h1v10l-1 1-8 10 8 3h1v8l-1 1-15-6-1-1v-3zM433 48l1-2h1l5-3 1 1-13 46v1l-2 1-4 2h-1v-1l12-45zM460 55v2l-1 1-15 20h-1v-8l1-2v-1l7-8-7-2v-1l-1-1v-8h1v-1h1l14 6h1v3z",
    className: "st12"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Text_Box_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x7B__x7D__3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speach_Bubble_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_96_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_98_",
    d: "m191 7-91 45-2 3v44l2 3 9 4h5l91-44 2-4V15c0-1-1-3-3-3l-9-5h-4z",
    className: "st9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_97_",
    d: "M207 15c0-1-1-2-2-1l-91 45-2 1-13-7 1-1 91-45h5l9 5 2 3z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205 14-91 45-2 3v43c0 1 1 2 2 1l91-44 2-4V15c0-1-1-2-2-1z",
    className: "st2"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M134 70v8l1 1h3l1-1 1-2 1-1v-2l1-1 4-2 1 1a15 15 0 0 1-3 8 19 19 0 0 1-6 6l-4 1-3-1-2-3v-3l-1-4 1-3v-4l2-5 3-3 4-3 3-1 3 1 2 2 1 3-1 1-4 2h-1v-1l-1-1h-2l-2 2-1 1-1 2v2zM159 47l3-1 3 1 2 1v4l-4 1-1 1v-1h-3l-1 1-1 1h-1v2l1 1 2-1h2l3-1 2 1 1 2 1 3-1 3-2 4-3 3-3 2-4 1h-3l-1-2-1-2v-1h1l3-2h2l1 1 2-1 2-2 1-2v-1h-1l-2 1h-7l-2-5 1-3a15 15 0 0 1 4-7l4-2zM180 37l3-1h3l2 2v3l-4 2h-2l-1-1-1 1h-1l-1 1-1 1v2h3l3-1h2l2 1 2 1v3l-1 4-2 4-2 3-4 2-4 1h-2l-2-2-1-3 1-1 3-2h2v1h3l3-2 1-2-1-1h-3l-3 1-4-1-1-4v-4a15 15 0 0 1 4-6l4-2z",
    className: "st32"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Text_Box_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x7B__x7D__2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speach_Bubble_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    d: "m191 97-91 45-2 3v44l2 3 9 4h5l91-44 2-4v-43c0-1-1-3-3-3l-9-5h-4z",
    className: "st9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    d: "M207 105c0-1-1-2-2-1l-91 45-2 1-13-7 1-1 91-45h5l9 5 2 3z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205 104-91 45-2 3v43c0 1 1 2 2 1l91-44 2-4v-43c0-1-1-2-2-1z",
    className: "st2"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M135 149v27l-4 2h-1v-10l-6 3v9l-1 1v1l-4 2h-1v-26l1-1 4-2 1 1v9l6-3v-10l1-1 4-2zM156 139v6l-5 2v20l-1 1-4 2h-1v-20l-5 3-1-1v-4l1-1 16-8zM169 152l-3-5v13l-1 1-4 2v-27l4-2h1v1l5 8 4-13 1-1h1l3-2h1v26l-1 1-4 1c0 1 0 1 0 0v-13l-3 8a3 3 0 0 1-1 1l-2 1h-1zM200 138h1v5l-1 1-13 6h-1v-26l1-1 4-1c0-1 0-1 0 0h1v20l8-4z",
    className: "st32"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Text_Box_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x7B__x7D__1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speach_Bubble_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "m191 187-91 45-2 3v44l2 3 9 4h5l91-44 2-4v-43c0-1-1-3-3-3l-9-5h-4z",
    className: "st9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    d: "M207 195c0-1-1-2-2-1l-91 45-2 1-13-7 1-1 91-45h5l9 5 2 3z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205 194-91 45-2 3v43c0 2 1 2 2 1l91-44 2-4v-43c0-1-1-2-2-1z",
    className: "st2"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M136 249v8l1 1h3l1-1 1-1 1-2v-2l1-1 4-1c0-1 0-1 0 0h1a15 15 0 0 1-3 8 19 19 0 0 1-6 6l-4 1-3-1-2-3-1-3v-3l1-4v-4l2-4 3-4 4-3 3-1 3 1 2 2 1 3-1 1-4 2h-1v-1l-1-1h-1l-1 1-2 1-1 1-1 2v2zM162 244v8l-4 1h-1v-7l-4 3h-1v-6h1l4-2v-7l1-1 4-2v7l5-2h1v4l-1 1v1l-5 2zM182 234v7h-1v1l-4 2v-7l-5 2h-1v-4l1-1v-1l5-2v-8l4-1c0-1 0-1 0 0h1v6l4-2h1v6h-1l-4 2z",
    className: "st32"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerGrowth2);
export default __webpack_public_path__ + "static/media/career_growth_2.6e48e946b7841a73a30bad0c18d23e51.svg";
export { ForwardRef as ReactComponent };